import { AxiosResponse } from "axios"

import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyuyoNinusiListGetReq,
  TSyuyoNinusiListGetRes,
  TSyuyoNinusiListPutReq,
} from "./TSyuyoNinusi"

/**
 * 主要荷主に対するAPIリクエスト用サービス
 *
 * @export
 * @class TenkenService
 * @extends {ConnectApi}
 */
export default class TenkenService extends ConnectApi {
  /**
   * 主要荷主 一覧取得
   *
   * @param {TSyuyoNinusiListGetReq} params
   * @memberof SyuyouNinusiService
   */
  getList = async (params: TSyuyoNinusiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyuyoNinusiListGetRes[]>> =
        await this.getInner(`/master/syuyouninusi`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 主要荷主 更新
   * ※ 登録/削除を行う。
   *
   * @param {TSyuyoNinusiListPutReq} data
   * @memberof SyuyouNinusiService
   */
  put = async (data: TSyuyoNinusiListPutReq[]) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/syuyouninusi`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
